import React from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";

import { BlogType } from "src/shared/config";

type TagsAutocompleteProps = {
  tags: BlogType["tags"];
  onChange: (tags: BlogType["tags"]) => void;
};

export const TagsAutocomplete: React.FC<TagsAutocompleteProps> = (props) => {
  const { tags, onChange } = props;

  return (
    <Autocomplete
      fullWidth
      multiple
      size="small"
      options={tags}
      onChange={(_, value) => {
        onChange(value);
      }}
      // defaultValue={[top100Films[13].title]}
      freeSolo
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              variant="filled"
              color="primary"
              label={option}
              key={key}
              {...tagProps}
            />
          );
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          // variant="filled"
          label="Tag names"
          placeholder="Tag names"
        />
      )}
    />
  );
};
